import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../shared/services';
import { IVendorOnboardingDetails } from '../models/vendor-onboarding-model'

@Injectable({
  providedIn: 'root'
})

export class VendorOnboardingService {
  constructor(
    private http: HttpClient,
    private apiService: ApiService
  ) { }

  public InsertTempVendorDocuments(documentType: string, documentFile: File, emailLinkRefId: string): Observable<any> {
    const headers = new HttpHeaders().append('Content-Disposition', 'multipart/form-data');
    const input: FormData = new FormData();
    input.append("documentFile", documentFile);
    input.append("documentType", documentType);
    input.append("emailLinkRefId", emailLinkRefId);
    return this.http.post<any>(`${environment.apiRoot}VendorOnboardProcess/PostTempVendorDocuments`, input);
  }

  GetVendorOnboardProcess(emailLinkRefId):Observable<any>{
    return this.apiService.get(`VendorOnboardProcess/${emailLinkRefId}`)
}
SubmitVendorOnboardDetails(vendorOnboardDetails:IVendorOnboardingDetails): Observable<any> {
  return this.apiService.post(`VendorOnboardProcess/SubmitVendorOnboardProcess`,vendorOnboardDetails)
}

public getEmailValidityCheck(emailLinkId: string):Observable<any>{
  return this.apiService.get(`VendorOnboardProcess/CheckEmailValidity/${emailLinkId}`)
}

SubmitVendorOnboardDetailsApplicant(vendorOnboardDetails:any): Observable<any> {
  return this.apiService.post(`VendorOnboardProcess/SubmitVendorOnboardProcessApplicant`,vendorOnboardDetails)
}

public getCheckApplicantEmailValidity(emailLinkId: string):Observable<any>{
  return this.apiService.get(`VendorOnboardProcess/CheckApplicantEmailValidity/${emailLinkId}`)
}
}